import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import MainContent from '../MainContent';
import ContainerWithFooter from '../ContainerWithFooter';
import NavigationDrawer from '../NavigationDrawer';
interface MainLayoutProps {
  children: React.ReactNode;
  toggleDrawer: () => void;
  isDrawerOpen: boolean;
  desktopView?: boolean;
}

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    height: '100%'
  }
}));

const MainLayout: React.FC<MainLayoutProps> = ({
  children,
  toggleDrawer,
  isDrawerOpen,
  desktopView
}) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <NavigationDrawer
        toggleDrawer={toggleDrawer}
        isDrawerOpen={isDrawerOpen}
        desktopView={desktopView}
      />
      <MainContent>
        <ContainerWithFooter>{children}</ContainerWithFooter>
      </MainContent>
    </div>
  );
};

export default MainLayout;
